// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RequirePermission } from "@/components/shared/require-permission";
import { TransformationsList } from "@/features/ingress/transformations-list";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/ingress/transformations/")({
  component: () => (
    <RequirePermission permission={PAGE_PERMISSIONS.ingressTransformations}>
      <TransformationsList />
    </RequirePermission>
  ),
  validateSearch: z.object({ f: z.string().optional() }),
});
